// extracted by mini-css-extract-plugin
module.exports = {"container":"pages-event-container","borders":"pages-event-borders","credits":"pages-event-credits"};